var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { isEqual } from 'lodash';
import { useNamespace } from '@folio/stripes/core';
import { buildFiltersObject } from './helpers';
import { useSessionStorage } from '../../../../hooks';
import { DEFAULT_FILTERS } from './configurations';
var FILTERS_URL_KEY = 'filters';
var useURLFilters = function () {
    var _a;
    var history = useHistory();
    var location = history.location;
    var searchParams = new URLSearchParams(location.search);
    var namespace = useNamespace()[0];
    var _b = useSessionStorage("".concat(namespace, "/filters")), getItem = _b.getItem, setItem = _b.setItem;
    var sessionFilters = getItem();
    var setValues = function (filters) {
        searchParams.set(FILTERS_URL_KEY, filters.join(','));
        history.push("".concat(history.location.pathname, "?").concat(searchParams.toString()));
        setItem(filters.join(','));
    };
    useEffect(function () {
        var _a;
        var filtersURL = (((_a = searchParams.get(FILTERS_URL_KEY)) === null || _a === void 0 ? void 0 : _a.split(',')) || []).filter(function (filter) {
            return !!filter;
        }).join(',');
        if (sessionFilters === filtersURL) {
            return;
        }
        if (!sessionFilters && !filtersURL) {
            setValues(DEFAULT_FILTERS);
            return;
        }
        if (filtersURL) {
            setItem(filtersURL);
        }
        if (!filtersURL && sessionFilters) {
            history.push("".concat(history.location.pathname, "?").concat(FILTERS_URL_KEY, "=").concat(sessionFilters));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sessionFilters]);
    var filters = (((_a = searchParams.get(FILTERS_URL_KEY)) === null || _a === void 0 ? void 0 : _a.split(',')) || []).filter(function (filter) {
        return !!filter;
    });
    return {
        filterParams: filters,
        addValue: function (filterValue) {
            setValues(__spreadArray(__spreadArray([], filters, true), [filterValue], false));
        },
        removeValue: function (filterValue) {
            var newFilters = filters.filter(function (item) {
                return item !== filterValue;
            });
            setValues(newFilters);
        },
        resetFilters: function () {
            setValues(DEFAULT_FILTERS);
        },
        setValues: setValues
    };
};
export function useFilters() {
    var _a = useURLFilters(), filterParams = _a.filterParams, addValue = _a.addValue, removeValue = _a.removeValue, resetFilters = _a.resetFilters, setValues = _a.setValues;
    var filterCount = filterParams === null || filterParams === void 0 ? void 0 : filterParams.length;
    var onChangRecordType = function () {
        var a = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            a[_i] = arguments[_i];
        }
        var fil = filterParams.filter(function (item) {
            return !item.startsWith('record_types');
        });
        setValues(__spreadArray(__spreadArray([], fil, true), a, true));
    };
    var onChangeFilter = function (e) {
        var _a = e.target, checked = _a.checked, name = _a.name;
        if (checked) {
            addValue(name);
        }
        else {
            removeValue(name);
        }
    };
    var onResetAll = function () {
        resetFilters();
    };
    var onClearGroup = function (groupName) {
        var filters = filterParams.filter(function (filterName) {
            return !filterName.startsWith(groupName);
        });
        setValues(filters);
    };
    var selectedRecordTypes = filterParams.filter(function (value) {
        return value.startsWith('record_types');
    });
    var isDefaultState = isEqual(DEFAULT_FILTERS, filterParams);
    return {
        onChangeFilter: onChangeFilter,
        onChangRecordType: onChangRecordType,
        onClearGroup: onClearGroup,
        onResetAll: onResetAll,
        filterCount: filterCount,
        activeFilters: filterParams,
        selectedRecordTypes: selectedRecordTypes,
        filtersObject: buildFiltersObject(filterParams),
        isDefaultState: isDefaultState
    };
}
